<template>
    <div class="layout--full-page-topnav" style="position: relative">
        <TheMainNavbarHorizontal style="position: fixed" />
        <!-- <transition name="slide">
            <router-view></router-view>
        </transition> -->
        <router-view></router-view>
        <!-- <TheFooter /> -->
    </div>
</template>  
<script>
import TheMainNavbarHorizontal from '@/layouts/components/navbar/TheMainNavbarHorizontal.vue'
import TheFooter from '@/layouts/components/TheFooterNavHorizontal.vue'
export default {
    components: {
        TheMainNavbarHorizontal,
        TheFooter
    },
    data() {
        return {
            scrollState: true
        }
    }
    
}
</script>
<style>
    .layout--full-page-topnav {
        -webkit-user-select: none;  
        -moz-user-select: none;  
        -ms-user-select: none;  
        -o-user-select: none;  
        user-select: none;
    }
</style>